import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Panel = styled.div``;

export const PreferencesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  padding: ${space['space-600']} 0;

  & + & {
    border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space['space-200']};
`;

export const OtherInputWrapper = styled.div``;

export const FreeTextWrapper = styled.div`
  & textarea {
    width: 100%;
    box-sizing: border-box;
    min-height: 72px;
    padding: ${space['space-600']} ${space['space-500']};
    border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
    border-radius: ${size.radius['radius-md']};
    font-family: ${fonts.body};
    font-size: ${fonts.size.base};
    line-height: ${primitives.typography.lineHeight.normal};
    color: ${semantic.text.primary};
    resize: none;
    outline: none;

    &::placeholder {
      color: ${semantic.text.tertiary};
    }

    &:focus {
      border-color: ${semantic.border.selected};
    }
  }
`;

export const LabelText = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;
